import { useMemo } from 'react'
import { ClientSideTable } from '../Table'

import ProductCell from './Components/ProductCell'
import QuantityCell from './Components/QuantityCell'
import { useLang } from '_metronic/i18n/Metronici18n'
import moment from 'moment'

interface Props {
	id: number
	uuId: string
	code: string | null
	version: number
	contractId: number | null
	inquiryId: number
	supplierId: number
	buyerId: number | null
	documentStatus: string

	createdAt: string

	items: {
		id: number
		requestPrice: number
		quotePrice: number | null
		quantity: number
		quotationId: number
		title: string
		remark: string
		isFixed: boolean
		isSelected: boolean
		productId: number
		oemRequestItemId: number
	}[]

	inquiry: {
		id: number
		uuId: string
		code: string
		oemRequestId: number
		supplierId: 43
		buyerId: string | null
		status: string
		createdAt: string
		updatedAt: string
		oemRequest: {
			id: number
			uuId: string
			code: string
			buyerId: string | null
			createdAt: string
			updatedAt: string
			expiredAt: string | null
			createdByRole: 'buyer' | 'supplier' | 'admin'
			locationScopeMethod: string
			latitude: number
			longitude: number
			distance: number
			items: [
				{
					id: number
					uuId: string
					oemRequestId: number
					productId: number
					thicknessId: number
					outerMaterialId: number
					innerMaterialId: number
					printingOptionId: number
					printingOptionDetail: string | null
					formingId: number
					product: {
						id: number
						sortOrder: number
						code: string
						nameTh: string
						nameEn: string
						slug: string
						featurePicturePath: string
						productLine: {
							id: number
							nameTh: string
							descriptionTh: string
							nameEn: string
							descriptionEn: string
							sortOrder: number
							slug: string
							isActive: boolean | number
							featurePicturePath: string
							parentId: number | null
							parentTitle: string | null
						}
					}
				}
			]
		}
		statusTitleEn: string
		statusTitleTh: string
	}
	statusTitleEn: string
	statusTitleTh: string

	viewDetail?: () => void
	onDelete?: () => void
}

const QuotationCard: React.FC<Props> = ({
	code,
	documentStatus,
	statusTitleEn,
	statusTitleTh,
	createdAt,
	items = [],
	inquiry = {
		oemRequest: {
			items: [],
		},
	},
	viewDetail,
	onDelete,
}) => {
	const currentLanguage = useLang()

	const buttonClass = useMemo(() => {
		if (documentStatus === '10') {
			return 'btn btn-sm btn-kumopack-warning-50 text-kumopack-warning-600 fw-bold'
		}

		if (documentStatus === '20') {
			return 'btn btn-sm btn-kumopack-success-600 text-kumopack-base-white fw-bold'
		}

		return 'btn-sm btn btn-kumopack-secondary-600 text-kumopack-base-white fw-bold'
	}, [documentStatus])

	const data = useMemo(() => {
		return items
			.map(item => {
				const findedItem = inquiry.oemRequest.items.find(
					// @ts-ignore
					oemItem => parseInt(oemItem.id ?? '0') === item.oemRequestItemId
				)

				return {
					...item,
					...findedItem,
				}
			})
			.filter(item => item.isFixed)
	}, [items, inquiry])

	const columns: any[] = [
		{
			Header: currentLanguage === 'en' ? 'Product' : 'สินค้า',
			accessor: 'product',
			width: '75%',
			minWidth: '75%',
			Cell: ({ value }: any) => <ProductCell {...value} />,
		},
		{
			Header: () => (
				<div className="text-end">{currentLanguage === 'en' ? 'Quantity' : 'จำนวน'}</div>
			),
			accessor: 'quantity',
			width: '25%',
			minWidth: '25%',
			Cell: ({ value, row }: any) => {
				let unit = ''
				if (row.original.isFixed) {
					unit = currentLanguage === 'en' ? 'pcs' : 'ชิ้น'
				} else {
					unit = currentLanguage === 'en' ? 'item' : 'รายการ'
				}

				return <QuantityCell quantity={value} unit={unit} />
			},
		},
	]

	return (
		<div className="card border border-kumopack-grey-200">
			{/* begin:: Header */}
			<div className="card-header">
				<div className="d-flex flex-column flex-xl-row align-items-start align-items-xl-center justify-content-between w-100 my-5">
					{/* begin:: Title */}
					<div>
						<div className="d-flex flex-row align-items-center" style={{ columnGap: '12px' }}>
							<h4 className="text-kumopack-grey-900 fw-bold mb-0 hover-enabled cursor-pointer">
								{currentLanguage === 'en' ? 'Code' : 'หมายเลขที่ใบเสนอราคา'}:{' '}
								{String(code).length === 0 || !code ? '-' : code}
							</h4>
						</div>
					</div>
					{/* end:: Title */}

					{/* begin:: Status */}
					<div
						className="d-flex flex-row align-items-center mt-5 mt-xl-0"
						style={{ columnGap: '12px' }}>
						<button className={buttonClass} style={{ whiteSpace: 'nowrap' }}>
							{currentLanguage === 'en' ? statusTitleEn : statusTitleTh}
						</button>

						{/* {isDone ? (
                    <button
                        className="btn btn-sm btn-kumopack-secondary-50 text-kumopack-secondary-700 fw-bold"
                        style={{ whiteSpace: 'nowrap' }}>
                        ผู้ผลิต {supplier}
                    </button>
                ) : (
                    <div className="text-kumopack-grey-600 fw-bold">เหลือเวลา {remainingHours} ชม.</div>
                )}

                <button
                    className="btn btn-sm btn-kumopack-secondary-600 text-kumopack-base-white fw-bold"
                    style={{ whiteSpace: 'nowrap' }}>
                    {isDone
                        ? 'ผู้ผลิตส่งสินค้าแล้ว'
                        : `กำลังรอใบเสนอราคา ${remainingRequest}/${totalRequest}`}
                </button> */}

						{/* <button className="btn btn-sm white-button text-kumopack-grey-700 fw-bold">
                    ให้คะแนนสินค้า
                </button>

                <button
                    className="btn btn-sm btn-kumopack-secondary-600 text-kumopack-base-white fw-bold"
                    style={{ whiteSpace: 'nowrap' }}>
                    สั่งซื้ออีกครั้ง
                </button> */}
						{/* 
                <button className="d-none d-xl-block btn btn-icon btn-custom btn-active-light rounded-circle">
                    <img
                        src="/media/icons/kumopack/dots-vertical.png"
                        alt="Dot Vertical Icon"
                        width={20}
                        height={20}
                        style={{ userSelect: 'none', pointerEvents: 'none' }}
                    />
                </button> */}
					</div>
					{/* end:: Status */}
				</div>
			</div>
			{/* end:: Header */}

			<hr
				style={{
					background: 'transparent',
					borderBottom: '1px solid #CCC',
					borderTop: 0,
					borderLeft: 0,
					borderRight: 0,
					margin: 0,
				}}
			/>

			{/* begin:: Body */}
			<div className="card-body p-0">
				<ClientSideTable isGrey data={data} columns={columns} items_per_page={10} />

				<hr
					style={{
						background: 'transparent',
						borderBottom: '1px solid #CCC',
						borderTop: 0,
						borderLeft: 0,
						borderRight: 0,
						margin: 0,
					}}
				/>

				<div className="d-flex flex-row justify-content-between p-5">
					<div className="text-kumopack-grey-700">
						{currentLanguage === 'en' ? 'Created At' : 'สร้างเมื่อวันที่'}{' '}
						{moment(createdAt).format('DD-MM-YYYY')}
					</div>
					<div className="d-flex flex-row" style={{ gap: '12px' }}>
						<button
							className="btn btn-kumopack-primary-700 text-kumopack-base-white p-2 fs-7"
							onClick={viewDetail}>
							{currentLanguage === 'en' ? 'View Detail' : 'รายละเอียดเพิ่มเติม'}
						</button>
						{documentStatus === '10' && (
							<button
								className="btn btn-light-danger btn-active-danger p-2 px-4 fs-7"
								onClick={onDelete}>
								{currentLanguage === 'en' ? 'Delete' : 'ลบ'}
							</button>
						)}
					</div>
				</div>
			</div>
			{/* end:: Body */}
		</div>
	)
}

export default QuotationCard
